import { render, staticRenderFns } from "./fixedlist.vue?vue&type=template&id=3ec5821e&scoped=true"
import script from "./fixedlist.vue?vue&type=script&lang=js"
export * from "./fixedlist.vue?vue&type=script&lang=js"
import style0 from "./fixedlist.vue?vue&type=style&index=0&id=3ec5821e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec5821e",
  null
  
)

export default component.exports